<script setup lang="ts">
import { useApp } from '../stores/app';
import { t } from '../i18n';
import { profileCard } from '../profile-card';
import ProfileAvatar from './ProfileAvatar.vue';
import Icon from './Icon.vue';

/** One control: the profile picture and the word "Menu". Opens the navigation drawer. */
const app = useApp();
</script>

<template>
  <button type="button" class="float pillbar menu-pill" :aria-label="t('app.menu')" :aria-expanded="app.drawerOpen" @click.stop="app.drawerOpen = true">
    <ProfileAvatar v-if="profileCard.id" class="face" :id="profileCard.id" :first-name="profileCard.firstName" :last-name="profileCard.lastName" :avatar="profileCard.avatar" :size="32" />
    <Icon v-else name="menu" class="menu-ico" :size="18" />
    <span class="brand">{{ t('app.menu') }}</span>
  </button>
</template>

<style scoped>
.menu-pill {
  position: relative;
  box-sizing: border-box;
  width: var(--nav-rail);
  justify-content: center;
  gap: 0;
  height: 48px;
  padding: 0 16px;
  cursor: pointer;
  color: var(--text-2);
  font: inherit;
}
.menu-pill .face,
.menu-ico {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
}
.menu-pill:hover {
  color: var(--text);
}
.brand {
  font-weight: 500;
  color: var(--text);
}
</style>
